import { h, Component } from 'preact';
import s from 'components/bolt/main/legals/legals.sss';
import { joinClasses } from 'utils/utils';
import { geoFromIP } from 'utils/bolt/geo';

import Store from 'store/store';

export default class Legals extends Component {

	constructor(props) {
		super(props);
		this.props = props;
		this.handleCookieNoticeClick = this.handleCookieNoticeClick.bind(this);
		this.openExternalLink = this.openExternalLink.bind(this);
	}

	async componentDidMount() {
		const geo = await geoFromIP();
		const userInUS = geo?.countryCode?.toLowerCase() === 'us';
		this.setState({ userCountry: geo?.countryCode, userInUS });
	}

	handleCookieNoticeClick(btnLabel) {
		Store.emit('CUSTOM_EVENT', {
			category: 'central-navigation',
			action: 'legal-link-click',
			label: btnLabel
		});

		window.OneTrust.ToggleInfoDisplay();
	}

	openExternalLink(link, btnLabel) {
		Store.emit('CUSTOM_EVENT', {
			category: 'central-navigation',
			action: 'legal-link-click',
			label: btnLabel
		});

		window.open(link, '_blank');
	}

	renderDoNotSellLogo() {
		const { imageRoot } = this.props;
		return <img class={s.doNotSellLogo} src={`${imageRoot}/icons/your-privacy-choices.webp`} />;
	}

	render({ copy, legalsOpen, currentPage, toggleLegals }) {
		const isUpworld = currentPage === 'upWorld';
		const { userInUS } = this.state;
		return (
			<div 
				class={joinClasses(s.container, isUpworld && s.isUpworld, legalsOpen && s.open)}
				onMouseEnter={!legalsOpen && toggleLegals}
				onMouseLeave={legalsOpen && toggleLegals}
			>
				{copy.$legals.adChoices && (
					<button onClick={() => this.openExternalLink(copy.$legals.links.adChoices, copy.$legals.adChoices)}>
						<p>{copy.$legals.adChoices}</p>
					</button>
				)}
				{copy.$legals.cookiePreferences && (
					<button class={s.cookiePreferencesBtn} onClick={() => this.handleCookieNoticeClick(copy.$legals.cookiePreferences)}>
						{/* {userInUS && this.renderDoNotSellLogo()} */}
						<p>{copy.$legals.cookiePreferences}</p>
					</button>
				)}
				{copy.$legals.privacyPolicy && (
					<button onClick={() => this.openExternalLink(copy.$legals.links.privacyPolicy, copy.$legals.privacyPolicy)}>
						<p>{copy.$legals.privacyPolicy}</p>
					</button> 
				)}
				{copy.$legals.kidsHelp && (
					<button onClick={() => this.openExternalLink(copy.$legals.links.kidsHelp, copy.$legals.kidsHelp)}>
						<p>{copy.$legals.kidsHelp}</p>
					</button> 
				)}
				{copy.$legals.yourPrivacyPolicyChoices && (
					<button class={s.cookiePreferencesBtn} onClick={() => this.handleCookieNoticeClick(copy.$legals.yourPrivacyPolicyChoices)}>
						{userInUS && this.renderDoNotSellLogo()}
						<p>{copy.$legals.yourPrivacyPolicyChoices}</p>
					</button>
				)}
				{copy.$legals.cookieNotice && (
					<button onClick={() => this.openExternalLink(copy.$legals.links.cookieNotice, copy.$legals.cookieNotice)}>
						<p>{copy.$legals.cookieNotice}</p>
					</button>
				)}
				{copy.$legals.caNotice && (
					<button onClick={() => this.openExternalLink(copy.$legals.links.caNotice, copy.$legals.caNotice)}>
						<p>{copy.$legals.caNotice}</p>
					</button>
				)}
				{copy.$legals.termsOfService && (
					<button onClick={() => this.openExternalLink(copy.$legals.links.termsOfService, copy.$legals.termsOfService)}>
						<p>{copy.$legals.termsOfService}</p>
					</button>
				)}
				{copy.$legals.powster && (
					<button onClick={() => this.openExternalLink(copy.$legals.links.powster, copy.$legals.powster)}>
						<p>{copy.$legals.powster}</p>	
					</button>
					
				)}
				{copy.$legals.nbcUniversal && (
					<button>
						<p>{copy.$legals.nbcUniversal}</p>
					</button>
				)}
			</div>
		);
	}
}